import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import { BODYCONTRACT, PAGECONTRACT } from '../../Constants'
import moment from 'moment'
import SpinnerLoading from '../../components/spinner-loading'
import NavTitle from '../../components/nav-title'
import Error_false from '../../components/error/error-false'
import { useSelector } from 'react-redux'
import { useDebounce } from '@react-hook/debounce'
import { EMP_CONTRACT_COMPENSATION_SLIP_PDF } from '../../router/routes'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CardCustom from '../../components/custom/card-custom'
import NavRoleOrg from '../../components/nav-role-org'
import { BsArrowClockwise, BsSearch, BsSliders2Vertical } from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { Controller, useForm } from 'react-hook-form'
import LabelCustom from '../../components/label-custom'
import ModalCustom from '../../components/modal-custom'
import UseEmpsName from '../../hooks/use-emps-name'
import Autocomplete from '../../components/custom/autocomplete'
import { getContractAPI } from '../../services/contract'
import UseTypeYearSearch from '../../hooks/use-type-year'
import DatepickerCustom from '../../components/datepicker-custom'
import UseContractStatus from '../../hooks/use-contract-status'
import TextNavTitle from '../../components/TextNavTitle'
import detailImg from '../../images/Detail.svg'

function ContractNewPage() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const navigate = useNavigate()
  const [search, setSearch] = useDebounce('', 1000)

  const [showFilter, setShowFilter] = useState(false)
  const [page, setPage] = useState(1)
  const [keyName, setKeyName] = useDebounce('', 1000)
  const [isLoading, setIsLoading] = useState(true)
  const [totalPages, setTotalPages] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(0)
  const [numLoad, setNumLoad] = useState(1)
  const [dataEmps, setDataEmps] = useState([])
  const [phone, setPhone] = useState([])
  const typeYear = UseTypeYearSearch()
  const empName = UseEmpsName(orgId, keyName)
  const statusId = 1
  const bodyQuery = localStorage.getItem(BODYCONTRACT)
  const [isRefresh, setIsRefresh] = useState(false)
  const [filter, setFilter] = useState()
  const contractStatus = UseContractStatus()
  let [searchParams, setSearchParams] = useSearchParams()
  const searchMulti = searchParams.get('searchMulti')

  useEffect(() => {
    const d = JSON.parse(bodyQuery)
    d?.searchs && setValue('searchs', { value: d?.searchs, label: d?.searchs })
    d?.month && setValue('month', { value: d?.month, label: d?.monthName })
    d?.year && setValue('year', { value: d?.year, label: d?.year })
    d?.statusId &&
      setValue('statusName', { value: d?.statusId, label: d?.statusName })
    d?.nameFull &&
      setValue('empName', { value: d?.nameFull, label: d?.nameFull })
  }, [])

  useEffect(() => {
    const d = JSON.parse(bodyQuery)
    // let dataFilter = {
    //   statusId: d?.statusId ?? '',
    //   month: d?.month ?? '',
    //   year: d?.year ?? '',
    //   contractDate: d?.contractDate ?? '',
    //   searchs: d?.searchs ?? ''
    // }
    // setFilter(dataFilter)

    const body = {
      page: numLoad !== 1 ? 1 : page,
      orgId: orgId,
      statusId: d?.statusId ?? statusId,

      searchs: d?.searchs ?? searchMulti ?? search ?? '',
      ...(d?.month ? { month: d?.month } : ''),
      ...(d?.year ? { year: d?.year } : ''),
      ...(d?.contractDate ? { contractDate: d?.contractDate } : ''),
      ...(d?.nameFull ? { nameFull: d?.nameFull } : '')
      // ...filter
    }
    setPage(numLoad !== 1 ? 1 : page)

    if (orgId) {
      getEmps(body)
    }
    setNumLoad(numLoad + 1)
  }, [orgId, isRefresh, search])

  const getEmps = async (body) => {
    const data = await getContractAPI(body)
    setIsLoading(false)
    if (!data) return
    if (data.status) {
      setDataEmps(data.result)

      const cleanPhone = data.result.phone
        ? data.result.phone.replace(/\s/g, '')
        : ''
      setPhone(cleanPhone)
      setTotalPages(data.totalPages)
      setTotalRows(data.totalRows)
      setTotalLimits(data.totalLimits)
    } else {
      Error_false(data)
    }
    handleClose()
  }
  const clearSearch = () => {
    setValue('searchs', '')
    setValue('statusName', '')
    setValue('searchmulti', '')
    setValue('month', '')
    setValue('year', '')
    setValue('contractDate', '')
    setValue('statusId', '')
    setValue('empName', '')
    setSearchParams('')
    const body = {
      page: 1,
      orgId: orgId,
      statusId
    }
    setPage(1)
    setFilter({})
    // setBodyFilter({});
    localStorage.setItem(BODYCONTRACT, '{}')
    localStorage.setItem(PAGECONTRACT, 1)
    getEmps(body)
  }

  const handleClose = () => setShowFilter(false)
  const handleShow = () => setShowFilter(true)

  const onSubmit = (data) => {
    if (
      !data.searchs &&
      !data.month &&
      !data.year &&
      !data.contractDate &&
      !data.statusName &&
      !data.empName
    ) {
    } else {
      const datas = {
        searchs: data.searchs?.value ?? '',
        month: data.month?.value ?? '',
        monthName: data.month?.label ?? '',
        year: data.year?.value ?? '',
        contractDate: data.contractDate,
        // change to start_date
        statusId: data.statusName?.value ?? '',
        statusName: data.statusName?.label ?? '',
        nameFull: data.empName?.value ?? ''
      }
      setFilter(datas)
      const body = {
        page: 1,
        orgId,
        // statusId,
        ...(data.searchs?.value ? { searchs: data.searchs?.value } : ''),
        ...(data.month?.value ? { month: data.month?.value } : ''),
        ...(data.year?.value ? { year: data.year?.value } : ''),
        ...(data.contractDate ? { contractDate: data.startDate } : ''),
        ...(data.statusName?.value
          ? { statusId: data.statusName?.value }
          : statusId),
        ...(data.empName?.value ? { nameFull: data.empName?.value } : '')
      }
      setPage(1)
      localStorage.setItem(BODYCONTRACT, JSON.stringify(datas))
      localStorage.setItem(PAGECONTRACT, JSON.stringify(1))
      getEmps(body)
    }
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Contract</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12}>
        <CardCustom border="0" style={{ minHeight: '83vh' }}>
          <div
            className="d-flex justify-content-between p-3"
            style={{ flexWrap: 'wrap' }}
          >
            <div className="my-auto ">
              <label
                className=" my-auto fw-bold"
                style={{
                  fontSize: '14px'
                }}
              >
                Total: {totalRows?.toLocaleString()}
              </label>
            </div>
            {orgId ? (
              <div className=" d-flex justify-content-end gap-2">
                <Form.Group className="" style={{ minWidth: 300 }}>
                  <Controller
                    name={'searchmulti'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <InputGroup className="">
                        <InputGroup.Text className="bg-white border-end-0  text-muted">
                          <BsSearch />
                        </InputGroup.Text>

                        <Form.Control
                          placeholder="Contract No./ Code/ ID Card"
                          onChange={(e) => {
                            onChange(e) // Update the field value
                            setSearch(e.target.value) // Update the search term
                            setSearchParams('')
                          }}
                          value={value} // Set the value of the input field
                          className="border-start-0 ps-0 placeholder-text"
                        />
                      </InputGroup>
                    )}
                  />
                </Form.Group>

                <Button
                  size="sm"
                  type="button"
                  variant="light"
                  onClick={handleShow}
                  className="text-primary "
                >
                  <span className="m-3">
                    <BsSliders2Vertical /> Filter
                  </span>
                </Button>
                <Button
                  size="sm"
                  type="button"
                  variant="light"
                  onClick={() => clearSearch()}
                  className="text-primary "
                >
                  <BsArrowClockwise />
                </Button>
              </div>
            ) : (
              <></>
            )}
          </div>
          <Table hover className="mb-3">
            <thead
              className="bg-hrms"
              style={{ position: 'sticky', top: '0px', zIndex: 10 }}
            >
              <tr className="fw-light font-title-table">
                <th className="fw-normal">#</th>
                <th
                  className="fw-normal border-0"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Contract No.
                </th>
                <th className="fw-normal" style={{ minWidth: 'nowrap' }}>
                  Code
                </th>
                <th
                  className="fw-normal  border-0"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  ID Card
                </th>
                <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                  Start Date
                </th>
                <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                  Name
                </th>
                <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                  Nickname
                </th>
                <th
                  className="fw-normal text-center"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Group {/* สายงาน */}
                </th>
                {/* <th className="fw-normal" style={{ whiteSpace: "nowrap" }}>
                  Department 
                </th> */}

                <th
                  className="fw-normal text-center"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Department {/* แผนก */}
                </th>
                {/* <th className="fw-normal" style={{ whiteSpace: "nowrap" }}>
                  ทีม
                </th> */}
                <th className=" fw-normal" style={{ whiteSpace: 'nowrap' }}>
                  Position {/* ตำแหน่ง */}
                </th>
                <th className=" fw-normal" style={{ whiteSpace: 'nowrap' }}>
                  Status
                </th>
                <th
                  className=" fw-normal text-center"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {/* เทส */}
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {dataEmps.length > 0 ? (
                dataEmps.map((d, i) => (
                  <tr className="mb-3 fw-light font-small-2 " key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td>
                      <p className="font-small-2">{d?.contract_no || '-'}</p>
                    </td>
                    <td>
                      <p className="font-small-2">{d?.code || '-'}</p>
                    </td>
                    <td>
                      <p className="font-small-2">{d?.id_card || '-'}</p>
                    </td>
                    <td lg={1} className="my-auto">
                      <p className="mb-1 font-small-2">
                        {' '}
                        {d.start_date
                          ? moment(d.start_date)
                              // .add(543, 'year')
                              .format('DD/MM/YYYY')
                          : '-'}{' '}
                      </p>
                    </td>
                    <td lg={2} className="my-auto ">
                      <p className="mb-0  font-small-2 ">
                        {d.title_th}
                        {d?.name_th || ''} {d?.surname_th || '-'}
                      </p>
                    </td>
                    <td lg={1} className="my-auto">
                      <p className="mb-1  font-small-2">
                        {' '}
                        {d?.nickname_th || '-'}
                      </p>
                    </td>
                    <td lg={2} className="my-auto text-center">
                      <p className="mb-1 font-small-2"> {d?.division || '-'}</p>
                    </td>

                    <td lg={2} className="my-auto text-center">
                      <p className="mb-0  font-small-2">
                        {d?.department || '-'}
                      </p>
                    </td>

                    <td lg={1} className="">
                      <p className="mb-1  font-small-2">
                        {' '}
                        {d?.position_th || '-'}
                      </p>
                    </td>
                    <td lg={1} className="">
                      <p className="mb-1  font-small-2">
                        {' '}
                        {d?.status_th || '-'}
                      </p>
                    </td>
                    <td lg={1} className="">
                      <div className="d-flex justify-content-center">
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Detail</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                navigate(
                                  `${EMP_CONTRACT_COMPENSATION_SLIP_PDF}?orgId=${orgId}&code=${d.code}&idCard=${d.id_card}&phone=${d.phone}&statusId=${statusId}&contractNo=${d.contract_no}&searchMulti=${search}`
                                )
                              }}
                            >
                              <Image
                                src={detailImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </div>
                    </td>
                  </tr>
                ))
              ) : !orgId ? (
                <tr className="mb-0">
                  <td className="text-center small" colSpan={13}>
                    - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                  </td>
                </tr>
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(page) => {
                const body = {
                  page: page,
                  orgId: orgId,
                  statusId: statusId,
                  size: totalLimits
                }
                localStorage.setItem(PAGECONTRACT, JSON.stringify(dataEmps))
                getEmps(body)
                setPage(page)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
        <ModalCustom width={500} open={showFilter} onCancel={handleClose}>
          <h4>Filter</h4>
          <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
            <Row style={{ rowGap: '15px' }}>
              <Col xl={12} md={4}>
                <LabelCustom text="ชื่อพนักงาน" />
                <Controller
                  name={'empName'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Autocomplete
                      isClearable={true}
                      options={empName}
                      value={value}
                      onChange={onChange}
                      onInputChange={(data) => {
                        setKeyName(data)
                      }}
                    />
                  )}
                />
              </Col>
              <Col xl={6} md={4}>
                <LabelCustom text="Month" />
                <span className="text-secondary small">
                  {' '}
                  (เดือนที่พนักงานเซ็นสัญญา)
                </span>
                <Controller
                  name={'month'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      options={[
                        {
                          value: 1,
                          label: 'January'
                        },
                        {
                          value: 2,
                          label: 'February'
                        },
                        {
                          value: 3,
                          label: 'March'
                        },
                        {
                          value: 4,
                          label: 'April'
                        },
                        {
                          value: 5,
                          label: 'May'
                        },
                        {
                          value: 6,
                          label: 'June'
                        },
                        {
                          value: 7,
                          label: 'July'
                        },
                        {
                          value: 8,
                          label: 'August'
                        },
                        {
                          value: 9,
                          label: 'September'
                        },
                        {
                          value: 10,
                          label: 'October'
                        },
                        {
                          value: 11,
                          label: 'November'
                        },
                        {
                          value: 12,
                          label: 'December'
                        }
                      ]}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>

              <Col xl={6} md={4}>
                <LabelCustom text="Year" />
                <span className="small text-secondary">
                  {' '}
                  (ปีที่พนักงานเซ็นสัญญา)
                </span>
                <Controller
                  name={'year'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      options={typeYear}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
              <Col xl={6} md={4}>
                <LabelCustom text="Contract Date" />
                <Controller
                  name={'contractDate'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <DatepickerCustom
                      clearSearch
                      value={value}
                      onChange={([date]) => {
                        setValue(
                          'contractDate',
                          date ? moment(date).format('YYYY-MM-DD') : ''
                        )
                      }}
                    />
                  )}
                />
              </Col>

              <Col xl={6} md={4}>
                <LabelCustom text="Status Progress" />
                <Controller
                  name={'statusName'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Autocomplete
                      placeholder={
                        value === 1 || statusId === 1
                          ? 'Waiting Employee'
                          : value == 2
                          ? 'Waiting PD'
                          : value == 3
                          ? 'Success'
                          : value == 4
                          ? 'Cancel'
                          : 'All'
                      }
                      value={value}
                      isClearable={true}
                      options={contractStatus}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.statusName?.message && (
                  <label className="small text-danger">
                    {errors.statusName.message}
                  </label>
                )}
              </Col>

              <Col
                xl={12}
                md={12}
                className="d-flex justify-content-center gap-2 text-end mt-4"
              >
                <Button
                  className=" px-4 "
                  variant="btn btn-outline-secondary"
                  onClick={handleClose}
                >
                  ยกเลิก
                </Button>
                <Button type="submit" className=" px-4">
                  <BsSearch /> ค้นหา
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalCustom>{' '}
      </Col>
    </Row>
  )
}

export default ContractNewPage
